import React from "react";
import { Select } from "@mantine/core";

import { useObjectStore } from "../zustand/objects";

const LinksToButton = ({ destination, id, uiTheme }) => {
  const { artboards, updateDestination, currentObjectArtboard, arrangeUndoRedo } = useObjectStore();

  const handleSelect = (mappedItem) => {
    // send current state to undoActions
    arrangeUndoRedo({
      updateType: "objectUpdate", 
      artboard: currentObjectArtboard, 
      objectID: id,
      undo:false,
      field: "destination"
      })
      // send update to zustand
    updateDestination({
      id: id,
      currentObjectArtboard: currentObjectArtboard,
      destination: mappedItem,
      undo: false
    })
  }

  const optionsMap = Object.keys(artboards).filter((mapped) => mapped !== currentObjectArtboard)
  const borderColour = uiTheme?.borderColour || "#E5E7EB";
  const iconColour = uiTheme?.iconColour || "#6A7282";
  const textColour = uiTheme?.textColour || "#111827";
  const placeholderColour = uiTheme?.placeholderColour || "#6A7282";
  


  return (

    // <div style={{ height: "100%", width:85, display: 'flex', justifyContent: 'flex-start', zindex: 1600, overflow: 'visible' }}>
      <Select
        // style={{zIndex:2000, borderRadius: '16px', dropdown:{zIndex:2000}, options:{zIndex:2000}, group:{zIndex:2000}}}
        // radius={16}
        size={'sm'}
        label="Links to scene"
        placeholder="Pick scene..."
        data={[...optionsMap]}
        clearable
        defaultValue={destination}
        onChange={(e) => e ? handleSelect(e) : handleSelect('')}
        styles={{
          label: { color: textColour, fontWeight: 600 },
          input: {
            color: textColour,
            borderColor: borderColour,
            "&:focus": { borderColor: borderColour },
            "&:focus-within": { borderColor: borderColour },
          },
          section: { color: iconColour },
          placeholder: { color: placeholderColour },
        }}
      />

    // </div>


  );
};

export default LinksToButton;
